import { useState } from "react";
import Swal from "sweetalert2";
import { firestore } from "../../firebase/firebase";
import "./forms.css";
import { RadioInput } from "./input";
import firebase from "firebase/compat/app";
const timestamp = firebase.firestore.FieldValue.serverTimestamp();
const type = "webform";

export default function WebFrom() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [appToDo, setAppToDo] = useState("");
  const [appFeatures, setAppFeatures] = useState("");
  const [appDetails, setAppDetails] = useState("");
  const [appFeaturesDetail, setAppFeaturesDetail] = useState("");
  const [guidLineReference, setGuidLineReference] = useState("");
  const [typesOfProject, setTypesOfProject] = useState("");
  const [docs, setDocs] = useState("");
  const [appStore, setAppStore] = useState("");
  const [thirdPartyService, setThirdPartyService] = useState("");
  const [whichThirdPartyService, setWhichThirdPartyService] = useState("");
  const [haveLogo, setHaveLogo] = useState("");
  const [digitalMarketingSolution, setDigitalMarketingSolution] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      firstName,
      lastName,
      email,
      "Briefly describe the app and what you want the app to do ?": appToDo,
      "Briefly mention the app features for types of users(admin, user, etc ).For e.g (login, products homepage, product details, checkout, confirmation)": appFeatures,
      "What aspects are already in place ? What needs to be added ? Will the app need to be built from scratch or can you provide existing assets/code ?": appDetails,
      "What features do you want in the app ?": appFeaturesDetail,
      "Are there any design guidelines or existing design layouts for our reference or need to be followed ?": guidLineReference,
      "What platforms will the app built for ?": typesOfProject,
      "Do you have current API/services documentation ?": docs,
      "Do you have existing accounts of Play Store or App Store ?": appStore,
      "Are there any third-party services to be used ? (E.g - Shiprocket, stripe , etc)": thirdPartyService,
      "If yes which third party services are to be used or need suggestions regarding that ?": whichThirdPartyService,
      "Do you have logo for your app ?": haveLogo,
      "Are you looking for Digital Marketing solutions for your application or product ?": digitalMarketingSolution,
      type,
      timestamp,
    };
    firestore
      .collection("EmailQueries")
      .add(data)
      .then((docRef) => {
        Swal.fire({
          position: "top",
          icon: "success",
          title: "We will get back to you in 24hrs",
          showConfirmButton: false,
          timer: 1500,
        });
        document.getElementById("resetBtn").click();
        // console.log("doc", docRef);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <form className={"scrobitsQuoteForm"} onSubmit={handleSubmit}>
      <div className={"formGroup"}>
        <label htmlFor="fName" className={"formLabel"}>
          First Name <span className={"red"}>*</span>
        </label>
        <input
          type="text"
          id="fName"
          className={"formInput"}
          placeholder="Your Answer"
          value={firstName}
          onChange={(e) => {
            setFirstName(e.currentTarget.value);
          }}
          required
        />
      </div>
      <div className={"formGroup"}>
        <label htmlFor="lName" className={"formLabel"}>
          Last Name <span className={"red"}>*</span>
        </label>
        <input
          type="text"
          id="lName"
          className={"formInput"}
          placeholder="Your Answer"
          value={lastName}
          onChange={(e) => {
            setLastName(e.currentTarget.value);
          }}
          required
        />
      </div>
      <div className={"formGroup"}>
        <label htmlFor="email" className={"formLabel"}>
          Please provide email <span className={"red"}>*</span>
        </label>
        <input
          type="email"
          id="email"
          className={"formInput"}
          placeholder="Your Answer"
          value={email}
          onChange={(e) => {
            setEmail(e.currentTarget.value);
          }}
          required
        />
      </div>
      <div className={"formGroup"}>
        <label htmlFor="appToDo" className={"formLabel"}>
          Briefly describe the app and what you want the app to do ?
          <span className={"red"}>*</span>
        </label>
        <textarea
          name="appToDo"
          id="appToDo"
          className={"formInput"}
          onChange={(e) => {
            setAppToDo(e.currentTarget.value);
            var textarea = e.currentTarget;
            textarea.style.height = textarea.scrollHeight + "px";
          }}
          value={appToDo}
          placeholder="Your Answer"
          required
        />
      </div>
      <div className={"formGroup"}>
        <label htmlFor="appFeatures" className={"formLabel"}>
          Briefly mention the app features for types of users(admin, user, etc
          ).For e.g (login, products homepage, product details, checkout,
          confirmation)
          <span className={"red"}>*</span>
        </label>
        <textarea
          name="appFeatures"
          id="appFeatures"
          className={"formInput"}
          onChange={(e) => {
            setAppFeatures(e.currentTarget.value);
            var textarea = e.currentTarget;
            textarea.style.height = textarea.scrollHeight + "px";
          }}
          value={appFeatures}
          placeholder="Your Answer"
          required
        />
      </div>
      <div className={"formGroup"}>
        <label htmlFor="appDetails" className={"formLabel"}>
          What aspects are already in place ? What needs to be added ? Will the
          app need to be built from scratch or can you provide existing
          assets/code ?<span className={"red"}>*</span>
        </label>
        <textarea
          name="appDetails"
          id="appDetails"
          className={"formInput"}
          onChange={(e) => {
            setAppDetails(e.currentTarget.value);
            var textarea = e.currentTarget;
            textarea.style.height = textarea.scrollHeight + "px";
          }}
          value={appDetails}
          placeholder="Your Answer"
          required
        />
      </div>
      <div className={"formGroup"}>
        <label htmlFor="appFeaturesDetail" className={"formLabel"}>
          What features do you want in the app ?{" "}
          <span className={"red"}>*</span>
        </label>
        <input
          type="text"
          id="appFeaturesDetail"
          name="appFeaturesDetail"
          className={"formInput"}
          placeholder="Your Answer"
          value={appFeaturesDetail}
          onChange={(e) => {
            setAppFeaturesDetail(e.currentTarget.value);
          }}
          required
        />
      </div>
      <div className={"formGroup"}>
        <label className={"formLabel"}>
          Are there any design guidelines or existing design layouts for our
          reference or need to be followed ? <span className={"red"}>*</span>
        </label>
        <RadioInput
          options={["yes", "no"]}
          id="guidLineReference"
          value={guidLineReference}
          setValue={setGuidLineReference}
        />
      </div>
      <div className={"formGroup"}>
        <label className={"formLabel"}>
          What platforms will the app built for ?{" "}
          <span className={"red"}>*</span>
        </label>
        <RadioInput
          options={["ios", "web", "dev"]}
          id="typeOfProject"
          value={typesOfProject}
          setValue={setTypesOfProject}
        />
      </div>
      <div className={"formGroup"}>
        <label className={"formLabel"}>
          Do you have current API/services documentation ?
          <span className={"red"}>*</span>
        </label>
        <RadioInput
          options={["yes", "no"]}
          id="serviceDocumentaion"
          value={docs}
          setValue={setDocs}
        />
      </div>
      <div className={"formGroup"}>
        <label className={"formLabel"}>
          Do you have existing accounts of Play Store or App Store ?
          <span className={"red"}>*</span>
        </label>
        <RadioInput
          options={["yes", "no"]}
          id="accOfStore"
          value={appStore}
          setValue={setAppStore}
        />
      </div>
      <div className={"formGroup"}>
        <label className={"formLabel"}>
          Are there any third-party services to be used ? (E.g - Shiprocket ,
          stripe , etc)
          <span className={"red"}>*</span>
        </label>
        <RadioInput
          options={["yes", "no"]}
          id="thirdPartyService"
          value={thirdPartyService}
          setValue={setThirdPartyService}
        />
      </div>
      <div className={"formGroup"}>
        <label htmlFor="fName" className={"formLabel"}>
          If yes which third party services are to be used or need suggestions
          regarding that ?<span className={"red"}>*</span>
        </label>
        <input
          type="text"
          id="whichThirdPartyService"
          className={"formInput"}
          placeholder="Your Answer"
          value={whichThirdPartyService}
          onChange={(e) => {
            setWhichThirdPartyService(e.currentTarget.value);
          }}
          required
        />
      </div>
      <div className={"formGroup"}>
        <label className={"formLabel"}>
          Do you have logo for your app ? <span className={"red"}>*</span>
        </label>
        <RadioInput
          options={["yes", "no", "No , But would like us to design for you"]}
          id="haveLogo"
          value={haveLogo}
          setValue={setHaveLogo}
        />
      </div>
      <div className={"formGroup"}>
        <label className={"formLabel"}>
          Are you looking for Digital Marketing solutions for your application
          or product ? <span className={"red"}>*</span>
        </label>
        <RadioInput
          options={["yes", "no"]}
          id="digitalMarketingSolution"
          value={digitalMarketingSolution}
          setValue={setDigitalMarketingSolution}
        />
      </div>

      <div className={"formGroupBtn"}>
        <input type="submit" className={"formInput"} value="Submit" />
        <input
          type="reset"
          className={"formInput"}
          value="reset"
          onClick={() => {
            setFirstName("");
            setLastName("");
            setEmail("");
            setAppToDo("");
            setAppFeatures("");
            setAppDetails("");
            setAppFeaturesDetail("");
            setGuidLineReference("");
            setTypesOfProject("");
            setDocs("");
            setAppStore("");
            setThirdPartyService("");
            setWhichThirdPartyService("");
            setHaveLogo("");
            setDigitalMarketingSolution("");
          }}
          id="resetBtn"
        />
      </div>
    </form>
  );
}
